export const iconFontAwesomeMapsPhoneFlip = (
	<i className="fa-solid fa-phone-flip"></i>
);
